export class SgKdConstants {

  /** 業務日付区分 */
  static readonly BUSINESS_DATE_KBN = "PCZZ0001";

  /**
   * 文字列
   */
  static readonly STR = {
    /** 空文字 */
    EMPTY: "",
    /** ハイフン */
    HYPHEN: "-",
  };

  /**
   * 処理結果コード
   */
  static readonly RESULT_CODE = {
    /** 正常 */
    NORMAL_END: "0",
    /** 異常 */
    ABNORMAL_END: "9",
  };

  /**
   * 画面遷移パス
   */
  static readonly PATH = {
    /** 【共通】作業管理メニュー画面 */
    MANAGE_MENU: "/sgkz001d/",
    /** 【共通】完了画面 */
    COMPLETE: "/sgkz003d/"
  };

  /**
   * 受付基盤画面遷移情報
   */
  static readonly SGKA_PATH = {
    /** ベースURL */
    BASE_URL: "https://xxxxxxxx",
    /** 固定URL(Sandbox)
     */
    FIXED_URL: "--cisdev1.sandbox.lightning.force.com",
    /** 固定URL（本番環境） */
    // FIXED_URL: "lightning.force.com",
    /** リダイレクト用ページ */
    REDIRECR_PAGE: "/lightning/n/tab_sgkd010",
    /** パラメタ */
    PARAM: '`?c__${key}=${value}`'
  };

  /**
   * フラグ
   */
  static readonly FLG = {
    /** ON */
    ON: "1",
    /** OFF */
    OFF: "0",
  };

  /**
   * メッセージ
   */
  static readonly MESSAGE = {
    /** インフォ */
    INFO: {
      /** メッセージクラス */
      MESSAGE_CLS: "mat-card-background-primary",
      /** アイコン */
      ICON: "done",
      /** アイコンクラス */
      ICON_CLS: "mat-icon-color-primary",
    },
    /** エラー */
    ERROR: {
      /** メッセージクラス */
      MESSAGE_CLS: "mat-card-background-error",
      /** アイコン */
      ICON: "cancel",
      /** アイコンクラス */
      ICON_CLS: "mat-icon-color-error",
    },
    /** ワーニング */
    WARN: {
      /** メッセージクラス */
      MESSAGE_CLS: "mat-card-background-warning",
      /** アイコン */
      ICON: "warning",
      /** アイコンクラス */
      ICON_CLS: "mat-icon-color-warning",
    }
  };

  /**
   * コード
   */
  static readonly CODE = {

    /** 支払方法登録方法区分 */
    PAY_METHOD_REG_MTD_DIV: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200270",
      /** ユーザコード */
      USER_CODE: {
        /** オンライン */
        ONLINE: "1",
      }
    },

    /** 預金種別 */
    DPTCLSFY: {
      /** 画面項目ID */
      DISP_ITEM_ID: "C000361"
    },

    /** 支払方法 */
    PAYMETHOD: {
      /** 画面項目ID */
      DISP_ITEM_ID: "C000918",
      /** ユーザコード */
      USER_CODE: {
        /** ＣＶＳ払込票 */
        CVS: "1",
        /** 口座振替 */
        KOUZA: "2",
        /** 口座振替（ゆうちょ） */
        KOUZA_Y: "3",
        /** クレジット */
        CRD: "4",
        /** 請求書払い */
        SEIKYU: "5",
        /** 特定払込票 */
        TOKUTEI: "C",
        /** ＳＭＳ決済 */
        SMS: "D",
      }
    },

    /** 受取方法 */
    RECIV_METHOD: {
      /** 画面項目ID */
      DISP_ITEM_ID: "C009160"
    },

    /** クレジット企業コード */
    CRD_COM_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "C014020"
    },

    /** 申込書送付ステータスコード */
    SRNDOC_SEND_STS_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200130",
      /** ユーザコード */
      USER_CODE: {
        /** 受付 */
        ACEPT: "0"
      }
    },

    /** 申込書種別コード */
    SRNDOC_CLSFY_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S200140",
      /** ユーザコード */
      USER_CODE: {
        /** 口振 */
        KOHURI: "01"
      }
    },

    /** 会社コード */
    COM_CODE: {
      /** 画面項目ID */
      DISP_ITEM_ID: "S900020"
    },

    /** 請求区分 */
    CLAIM_DIV: {
      /** 口座振替 */
      KOHURI: '02'
    },

    /** 請求ステータス */
    CLAIM_STS: {
      /** 返却中 */
      REQRET: '03'
    },
  
    /** 口振翌月請求区分コード */
    KOHURI_NMCDIV: {
      /** 当月口座振替 */
      TOUGETSU: '0'
    },

  };

  /** コード_取得対象テーブル区分_請求先 */
  public static readonly CODE_SHTKTARGETTBLDIV_SEIKYUSAKI: string = "1";
  /** コード_取得対象テーブル区分_供給先 */
  public static readonly CODE_SHTKTARGETTBLDIV_KYOKYUSAKI: string = "4";
  /** コード_参照先テーブル区分_2 */
  public static readonly CODE_REFBYTBLDIV_2: string = "2";
  /** コード_参照先テーブル区分_3 */
  public static readonly CODE_REFBYTBLDIV_3: string = "3";

  /**
   * 支払方法変更画面
   */
  static readonly SGKD002D = {

    /** 画面ID */
    GAMEN_ID: "SGKD002D",
    /** 最大長 */
    MAX_LENGTH: {
      /** 口座名義（漢字） */
      KOUHURI_ACT_KNJ: 24,
      /** 口座名義（カナ） */
      MEIGI_KANA: 30,
      /** 金融機関コード */
      EXT_BANKFC_CODE: 4,
      /** 支店コード */
      EXT_BRANCH_CODE: 3,
      /** 口座番号 */
      KOUZA_NO: 7,
      /** カード名義（カナ） */
      CARD_MAIGI_KANA: 30,
      /** DBキー */
      CRD_LINK_KEY: 16,
      /** 携帯電話番号 */
      CELLPHONENUMBER: 13,
    },
  };

  /**
   * 口座振替依頼返却内訳表出力画面
   */
  static readonly SGKD010D = {

    /** 最大長 */
    MAX_LENGTH: {
      /** 金融機関コード */
      EXT_BANKFC_CODE: 4
    },
  };

  /**
   * 宛名印刷登録画面
   */
  static readonly SGKD019D = {

    /** 最大長 */
    MAX_LENGTH: {
      /** 請求契約番号 */
      CLAIM_CTR_NO: 10,
      /** 供給地点特定番号(電気) */
      SUPPNT_SPNO_D: 22,
      /** 供給地点特定番号(ガス) */
      SUPPNT_SPNO_G: 17,
      /** 郵便番号 */
      POST_NO: 8,
      /** 都道府県 */
      PFC_ANAME: 5,
      /** 行政市区 */
      ADMNCWNM: 36,
      /** 行政町名 */
      ADMNTNM: 36,
      /** 丁目 */
      CHOME: 36,
      /** 番地・号 */
      BUILDING_NUMBER: 50,
      /** 住宅・号棟漢字名 */
      VISIT_SUPADR: 50,
      /** 屋号・業種漢字名 */
      VISIT_YAGOU: 30,
      /** 送付先宛名 */
      SENDTO_ADDRESS: 50,
      /** 発行元 - 住所 */
      HAKKOMOTO_ADDR: 50,
      /** 発行元 - 問い合わせ窓口 */
      CONTACT_MADOGUCHI: 30,
      /** 電話番号 */
      TEL_NO: 12,
    },
  };

  /**
   * パターン
   */
  static readonly PATTERN = {
    /** 半角数値 */
    HAN_NUM: /\d+/,
    /** 電話番号 */
    TEL_NO: /(\d|-)+/,
    /** 郵便番号 */
    POST_NO: /^\d{3}-?\d{4}$/,
    /** 全角カナ(全角スペース含) */
    ZEN_KANA: /[ァ-ヶー　]+/,
    /** 供給地点特定番号 */
    SUPPNT_SPNO: /^\d{17}(\d{5})?$/
  }
}
